<template>
    <div class="newPage">
        <div class="content">
            <!--方案配置-->
            <!--<breadcrumb></breadcrumb>-->
            <div style="padding: 20px">
                <el-row :gutter="10" class="mb8">
                    <el-col :span="1.5">
                        <el-button type="primary"
                                   icon="el-icon-plus"
                                   size="mini"
                                   @click="add">新增
                        </el-button>
                    </el-col>
                </el-row>

            </div>
            <div >
                <el-table v-loading="loading"
                          :data="tableData.list"
                >


                    <el-table-column label="推送名称" align="center" prop="name">
                        <template slot-scope="scope">
                            {{JSON.parse(scope.row.params).name}}
                        </template>
                    </el-table-column>
                    <el-table-column label="cron表达式" align="center" prop="cronExpression">
                    </el-table-column>
                    <el-table-column label="状态" align="center" prop="stations">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status==0" type="primary">正常</el-tag>
                            <el-tag v-if="scope.row.status==1" type="success">关闭</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间" align="center" prop="createTime">
                    </el-table-column>
                    <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                        <template slot-scope="scope">
                            <el-button
                                    size="mini"
                                    type="text"
                                    @click="handleUpdate(scope.row)"
                            >详情
                            </el-button>

<!--                            <el-button-->
<!--                                    v-if="scope.row.status===0"-->
<!--                                    size="mini"-->
<!--                                    type="text"-->

<!--                                    @click="handleUpdate(scope.row)"-->
<!--                            >关闭-->
<!--                            </el-button>-->

<!--                            <el-button-->
<!--                                    v-if="scope.row.status===1"-->
<!--                                    size="mini"-->
<!--                                    type="text"-->
<!--                                    @click="handleUpdate(scope.row)"-->
<!--                            >启用-->
<!--                            </el-button>-->

                            <el-button
                                    size="mini"
                                    type="text"
                                    @click="handleDelete(scope.row)"
                            >删除
                            </el-button>

                            <el-button
                                    size="mini"
                                    type="text"
                                    @click="handleRun(scope.row)"
                            >手动执行
                            </el-button>


                            <template v-if="!scope.row.apply">
                                <el-button
                                        size="mini"
                                        type="text"
                                        @click="handleRecord(scope.row)"
                                >记录
                                </el-button>
                            </template>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <pagination
                    v-show="tableData.totalCount>0"
                    :total="tableData.totalCount"
                    :page.sync="queryParams.page"
                    :limit.sync="queryParams.pageSize"
                    @pagination="getList"
            />
        </div>


        <el-dialog title="推送配置" :visible.sync="open" width="750px" append-to-body size="mini">
            <el-form ref="form" :model="form" size="mini" :rules="rules" label-width="140px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="推送名称" prop="name">
                            <el-input size="mini" v-model="form.name" placeholder="请输入推送名称"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="城市" prop="code">
                            <el-cascader
                                    v-model="form.code"
                                    :props="{label:'name',value:'code',emitPath:false}"
                                    :options="regionTree"
                                    @change="getModuleTree"></el-cascader>
                        </el-form-item>
                    </el-col>

                    <template v-for="(item,index) in form.list">
                        <div :key="index">
                            <el-col :span="10">
                                <el-form-item label="模块" prop="menuId">
                                    <el-cascader
                                            v-model="item.menuId"
                                            :props="{label:'title',value:'menuId',emitPath:false}"
                                            :options="menuTree"
                                            @change="getModuleType(index, $event)"
                                    ></el-cascader>
                                </el-form-item>
                            </el-col>
                            <el-col :span="10">
                                <el-form-item label="类型" prop="moduleIds">
                                    <el-select v-model="item.moduleIds" collapse-tags size="mini" multiple placeholder="请选择类型">
                                        <el-option
                                                v-for="items in item.moduleList"
                                                :key="items"
                                                :label="items"
                                                :value="items">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="3">
                                <el-button icon="el-icon-plus" size="mini"  type="primary" v-if="index+1===form.list.length" @click="formListPush"></el-button>
                                <el-button icon="el-icon-minus"  size="mini" v-if="index+1!==form.list.length"  type="primary" @click="formListMinus(index)" ></el-button>
                            </el-col>
                        </div>
                    </template>
                    <el-col :span="24">
                        <el-form-item label="cron表达式" prop="cronExpression">
                            <el-input
                                    size="mini"
                                    v-model="form.cronExpression"
                                    placeholder="cron表达式"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="推送邮箱" prop="email">
                            <el-input
                                    size="mini"
                                    v-model="form.email"
                                    placeholder="推送邮箱"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="状态" prop="status">
                            <el-switch
                                    style="display: block"
                                    v-model="form.status"
                                    :active-value="0"
                                    :inactive-value="1"
                                 >
                            </el-switch>

                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="open=false">取 消</el-button>
            </div>
        </el-dialog>


        <el-dialog title="推送记录" :visible.sync="openRecord" width="750px" append-to-body size="mini">

            <el-table
                    v-if="recordData"
                    :data="recordData.list"
                    style="width: 100%">
                <el-table-column
                        prop="createTime"
                        label="开始执行时间"
                       >
                </el-table-column>
                <el-table-column
                        label="耗时"
                    >
                    <template slot-scope="scope" >

                        <div v-if="scope.row.times">
                            {{(scope.row.times/1000).toFixed(2)}} 秒
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        label="状态">
                    <template slot-scope="scope">
                        <div  v-if="scope.row.status==0">
                            <el-tag type="primary">成功</el-tag>
                        </div>
                        <div v-if="scope.row.status==1">
                            <el-popover
                                    placement="top-start"
                                    title="失败信息"
                                    width="200"
                                    trigger="hover"
                                    :content="scope.row.error">
                                <el-tag type="danger" slot="reference">失败</el-tag>
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <pagination
                    v-show="recordData.totalCount>recordForm.pageSize"
                    :total="recordData.totalCount"
                    :page.sync="recordForm.page"
                    :limit.sync="recordForm.pageSize"
                    @pagination="handleRecord"
            />

            <div slot="footer" class="dialog-footer">
                <el-button @click="openRecord=false">关 闭</el-button>
            </div>
        </el-dialog>


    </div>
</template>

<script>
    import url from "../../utils/UrlApi"

    export default {
        name: "timedPush",
        data(){
            return {
                open:false,
                openRecord:false,
                form: {
                    name:'',
                    code:'',
                    list:[{menuId:'',moduleIds:[],moduleList:[]}],
                    cronExpression:'',
                    email:'',
                    status:0
                },
                loading:false,
                queryParams:{
                    page: 1,
                    pageSize: 10
                },
                tableData:{
                    totalCount:0
                },
                regionTree:[],
                menuTree:[],
                rules:{
                    name: [
                        { required: true, message: '请输入推送名称', trigger: 'change' }
                    ],
                    code: [
                        { required: true, message: '请选择城市', trigger: 'change' }
                    ],
                    cronExpression: [
                        { required: true, message: '请输入cron表达式', trigger: 'change' }
                    ],
                    email: [
                        { required: true, message: '请输入推送邮箱', trigger: 'change' }
                    ],
                },
                recordForm:{
                    page:1,
                    pageSize:10,
                    jobId:'',
                },
                recordData:[],
            }
        },
        mounted(){
            this.getList()
        },
        methods:{

            // 查列表
            getList(){
                this.$http.get(url.pushPagejob, {
                    params: {
                        page: this.queryParams.page,
                        pageSize: this.queryParams.pageSize
                    }
                }).then(res => {
                    if (res.data.code === '200') {
                        this.tableData = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 查询区域树

            getRegionTree(){
                this.$http.get(url.pushRegionTree, {
                    params: {}
                }).then(res => {
                    if (res.data.code === '200') {
                        this.regionTree = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            // 查询模块树
            getModuleTree(code){
                this.$http.get(url.pushMenuTree, {
                    params: {code:code}
                }).then(res => {
                    if (res.data.code === '200') {
                        this.menuTree = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            // 查询类别
            getModuleType(index,menuId){
                this.$http.get(url.pushModule, {
                    params: {menuId:menuId,code:this.form.code}
                }).then(res => {
                    if (res.data.code === '200') {
                        this.form.list[index].moduleList = res.data.data
                        this.form.list[index].moduleIds = ''


                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },


            formListPush(){
                this.form.list.push({menuId:'',moduleIds:[],moduleList:[]})
            },
            formListMinus(index){
                this.form.list.splice(index,1)
            },

            // 提交
            submitForm(){
                // 数据校验

                this.$refs["form"].validate(valid => {
                    if (valid){

                        let stu = false

                        let list = this.form.list
                        for (let i = 0; i < list.length; i++) {
                            if (!list[i].menuId){
                                stu = true
                                this.$message.error('第' + (i+1) +'列，请选择模块')
                                return;
                            }
                            if (!list[i].moduleIds.length){
                                stu = true
                                this.$message.error('第' +(i+1) +'列，请选择类型')
                                return;
                            }

                        }


                        let reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

                        let eList = this.form.email.split(',')

                        for (let i = 0; i < eList.length; i++) {
                            if(!reg.test(eList[i])){
                                stu = true
                                this.$message.error('邮箱格式错误')
                                return;
                            }
                        }

                        if(stu){
                            return
                        }


                        if(this.form.jobId){
                            this.$http.post(url.pushUpdatejob,this.form).then(res => {
                                if (res.data.code === '200') {
                                    this.$message.success('修改成功')
                                    this.open = false
                                    this.getList()
                                } else {
                                    this.$message.error(res.data.message)
                                }
                            })
                        }else {
                            this.$http.post(url.pushSavejob,this.form).then(res => {
                                if (res.data.code === '200') {
                                    this.$message.success('保存成功')
                                    this.open = false
                                    this.getList()
                                } else {
                                    this.$message.error(res.data.message)
                                }
                            })
                        }
                    }
                })
            },

            //  新增
            add(){
                this.getRegionTree()
                this.form= {
                    name:'',
                    code:'',
                    list:[{menuId:'',moduleIds:[],moduleList:[]}],
                    cronExpression:'',
                    email:''
                }
                this.open = true

            },

            // 修改
            handleUpdate(scope){

                this.getRegionTree()

                this.$http.get(url.pushInfo+scope.jobId, {
                    params: {}
                }).then(res => {
                    if (res.data.code === '200') {
                        let form = ''
                        form=  JSON.parse( res.data.data.params)
                        form.jobId =  res.data.data.jobId
                        form.status =  res.data.data.status

                        this.getModuleTree(this.form.code)
                        this.form = form
                        this.open = true

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

           // 删除
            handleDelete(scope){
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.post(url.pushDeletejob,[scope.jobId]).then(res => {
                        if (res.data.code === '200') {
                            this.$message.success('删除成功')
                            this.getList()
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                })
            },


            // 手动执行
            handleRun(scope){
                this.$http.post(url.pushRun,[scope.jobId]).then(res => {
                    if (res.data.code === '200') {
                        this.$message.success('手动执行成功')
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },


            // 记录
            handleRecord(scope){

                if(scope.jobId){
                    this.recordForm.jobId = scope.jobId
                }

                this.$http.get(url.pushLogpage, {
                    params: this.recordForm
                }).then(res => {
                    if (res.data.code === '200') {
                        this.recordData = res.data.data
                      this.openRecord = true
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            }

        }
    }
</script>

<style scoped>

</style>
